import { Client } from "@stomp/stompjs";
import { RequestCheckWalletStatus, UserCheckWalletStatus, WalletRiskLevel } from "./walletCheck";
import { TransactionType } from "./network";
import { CONTRACT_CURRENCY_ENUM } from "./contracts";
import { ContractStatus } from "./statuses";

export interface RequestStatusesEventData {
  requestNumber: string;
  status: string; // статус уже на русском
  statusDate: string;
  link: string;
  show: boolean;
}

export interface AmlStatusEventData {
  id: string;
  requestNumber: string;
  show: string;
  link: string;
  approvedNeededCheck: boolean;
}

export interface RequestWalletCheckEventData {
  amlId: string;
  checkId: string;
  riskStatus: RequestCheckWalletStatus;
  riskLevel: WalletRiskLevel;
  link: string;
}

export interface UserWalletCheckEventData {
  id: string; //checkId
  amlId: string; //amlId
  status: UserCheckWalletStatus;
  riskLevel: WalletRiskLevel;
  link: string;
}

export interface TransactionEventData {
  requestNumber: string;
  type: TransactionType;
  txhash: string;
  amount: string;
  currency: keyof typeof CONTRACT_CURRENCY_ENUM;
  link: string;
  show: boolean;
}

export interface RequestProcessingEventData {
  requestNumber: string;
  processingType: PROCESSING_TYPE;
  link: string;
  show: boolean;
}

export enum PROCESSING_TYPE_ENUM {
  FIAT_SENT = "FIAT_SENT",
  FIAT_RECEIVED = "FIAT_RECEIVED",
  TOKEN_RECEIVED = "TOKEN_RECEIVED",
  CUSTOMER_EXECUTED = "CUSTOMER_EXECUTED",
  AWAIT_CUSTOMER_EXECUTED = "AWAIT_CUSTOMER_EXECUTED",
}

export type PROCESSING_TYPE =
  | "FIAT_SENT"
  | "FIAT_RECEIVED"
  | "TOKEN_RECEIVED"
  | "CUSTOMER_EXECUTED"
  | "AWAIT_CUSTOMER_EXECUTED";

export interface WebSocketState {
  isConnected: boolean;
  client: Client | null;
}

export interface RubProcessingEventData {
  show: boolean;
  status: string;
  id: string;
  link: string;
  userIds: string[];
}

export interface NominalAccountDepositEventData {
  amount: string;
  link: string;
  show: boolean;
}

export interface QuoteExtendedEventData {
  requestNumber: string;
  processingType: PROCESSING_TYPE;
  link: string;
  show: boolean;
}

export interface DoubleControlEventData {
  requestNumber: string;
  processingType: PROCESSING_TYPE;
  link: string;
  show: boolean;
  type: "VERIFY_WALLET_REQUEST" | "VERIFY_WALLET_QUOTE";
}

export enum BALANCE_ENUM {
  TOKEN = "TOKEN",
  NATIVE = "NATIVE",
}

export interface BalanceEventData {
  requestNumber: string;
  link: string;
  address: string;
  balanceType: BALANCE_ENUM;
  amount: string;
}

export interface DocumentUpdatedEventData {
  requestNumber: string;
  link: string;
  show: boolean;
  documentId: string;
  fileName: string;
  action: "UPLOADED" | "REMOVED";
}
export interface BankStatementUpdatedEventData {
  requestNumber: string;
  link: string;
  show: boolean;
}

export enum BALANCE_TYPE_ENUM {
  OVERALL_BALANCES = "OVERALL_BALANCES",
  USER_BALANCES = "USER_BALANCES",
}

export interface NominalAccountUpdatedWebSocketEventData {
  totalBalance: string;
  availableBalance: string;
  blockedOnRequests: string;
  blockedForWithdrawal: string;
  balanceType: BALANCE_TYPE_ENUM;
  link: string;
  show: boolean;
}

export enum PAGE_PATH_ENUM {
  PENDING_ACTIONS = "pending-actions",
  BIDS = "bids",
  NOMINAL_ACCOUNT = "nominal-account",
}

export interface RubOperationWebSocketEventData {
  operationId: string;
  type: string;
  amount: number;
  companyId: string;
  createdAt: string;
}

export interface RubOperationsFeeUpdatedEvent {
  totalFee: number;
  monthFee: number;
  dayFee: number;
  show: boolean;
}

export enum SAFE_DEAL_STATE_ENUM {
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
}

export const safeDealStateTexts = {
  [SAFE_DEAL_STATE_ENUM.SUCCEEDED]: "Средства успешно выведены с Н/С",
  [SAFE_DEAL_STATE_ENUM.FAILED]: "Заявка на вывод рублей не выполнена. Повторите попытку",
};

export interface rubWithdrawalRequestSafeDealSucceedEvent {
  show: boolean;
  state: SAFE_DEAL_STATE_ENUM;
  companyId: string;
}

export interface ContractWebSocketEventData {
  unk: string;
  link: string;
  show: boolean;
}

export interface QuoteRejectWebSocketEventData {
  requestNumber: string;
  amount: number;
  fiatAmount: number;
  fiatCurrency: string;
  tokenCurrency: string;
  show: boolean;
  link: string;
}

export interface ContractStatusUpdatedWebSocketEventData {
  unk: string;
  link: string;
  show: boolean;

  contractHistory: {
    contractId: string;
    status: ContractStatus;
    statusDate: string;
    userId: string;
  };
}
